<template> 
    <div >
    <v-card class="filter-con">
    <div class="locations">
    <v-tabs :hide-slider="true" v-model="tabs" color="green">
        <v-tab
            class="tab-item"
            v-for="item in items"
            :key="item.tab"
        >
            {{ item.tab }}
        </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs">
        <v-tab-item
            v-for="item in items"
            :key="item.tab"
        >   
            <v-card flat>
            <div class="flex locations-con">
                <checkboxitem :key="keyforcheckbox" :statedata="statedata" @addstateid="storeStateID" @removestateid="removeID"/>

                <!-- <div class="loc" v-for="(item, index) in statedata" :key="index">
                    <div class="flex location">
                        <checkboxitem :key="keyforcheckbox" :item="item" @addstateid="storeStateID" @removestateid="removeID"/>
                    </div>
                </div> -->
            </div>

            <br>
            </v-card>
        </v-tab-item>
    </v-tabs-items>
    </div> 

    <div class="flex filter-buttons">
        <button @click="removeFilter()" class="remove">Remove filters</button>
        <button @click="applyFilter()" class="apply">APPLY FILTERS</button>
    </div>   
    </v-card> 
    </div>
</template>


<script>
import checkboxitem from "./checkboxitem"
import { mapActions } from "vuex";
import API_URL from "../../../../helpers/apiUrls";

export default {
    ...mapActions("StateFilterStore", "removestateid","removesinglestateid" ['addstatedata', "GET_STATE_ID"]),
    name: "filters",

    components: {
        "checkboxitem": checkboxitem,
    },

    data () {
      return {
            tabs: null,
            items: [
                { tab: 'Location', content: 'locations' },
            ],
            checkbox: false,
            statedata : [],
            stateIds : [], 
            removeStateID : [],
            keyforcheckbox: false,
        }
    },

    mounted(){
        this.getStateKey()
    },

    methods:{
        storeStateID(id){
            this.stateIds = [];
            this.stateIds.push(id);
        },
        removeID(id){
            this.stateIds = [];
            this.removeStateID.push(id);
            // console.log("STATE IDS", this.stateIds);
            this.stateIds = this.stateIds.filter(element => ![id].includes(element));
            // console.log("STATE IDS AFTER", this.stateIds);

        },

        removeFilter(){
            this.keyforcheckbox = true;
            this.$store.dispatch('StateFilterStore/removestateid'); 
            this.stateIds = []
            this.$emit('closefilter');
        },
        applyFilter(){
            this.$store.dispatch('StateFilterStore/removestateid'); 
            console.log("STATE IDS", this.stateIds);
            this.$store.dispatch('StateFilterStore/addstatedata', { stateid:this.stateIds});     
            // this.$store.dispatch('StateFilterStore/removesinglestateid', { stateid:this.removeStateID});     
            this.$emit('applyfilter');
            var storedata = this.$store.getters['StateFilterStore/GET_STATE_ID'];
            console.log("STORE DATA AFTER NEW ", storedata[0]);    
        },

        getStateKey(){
            const successHandler = response => {
                if(response.status === 200) {
                    this.statedata = response.data.results;
                }
            }
            const errorHandler = response => {
                this.showToast('Something went wrong internally!', 'error', 10000);
            }

            this.requestGET(
                `${API_URL.state_ids}`,
                {},
                {},
                successHandler,
                errorHandler,
                process.env.VUE_APP_API_BASE_URL_MY_FARMER,
            )             
        }
    }
}
</script>


<style lang="scss" scoped>
.filter-con{
    box-shadow: 3px 3px 7px rgba(23, 37, 20, 10);
    border-radius: 12px;
    padding: 20px;   
    width: 402px; 
    padding:auto;
    border: 0.2px solid rgb(163, 163, 163);
    max-height: 75vh;
    padding-bottom: 50px;
}
.con{
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    
}
.v-tab{
    text-transform: capitalize;
    font-size: 0.95rem;
    font-weight: 450;
    padding: 0px 0px;
    margin-right: 25px;
    min-width: 45px;
}
.v-tab--active{
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 12px;
    text-decoration-thickness: 2px;
    text-decoration-color: #1D8D56;
}
.input-field{
    border: 1px solid #BFBFBF;
    width: 100%;
    border-radius: 5px;
    padding: 12px;
    margin: 20px auto 10px;
}
.filter-buttons{
    // height: 10%;
    width: 90%;
    column-gap: 20px;
    position: fixed;
    bottom: 10px;
    background-color: #FFFFFF;
    z-index: 1;
    padding: 10px 0px;

    button{
        padding: 15px 20px;
        border-radius: 5px;
        font-size: 0.8rem;
        font-weight: 500;
    }
}
.remove{
    
    background-color: rgba(57, 186, 123, 0.11);
    width: 50%;
    color: #328736;
}
.apply{
    background-color: #36983B;
    width: 50%;    
    color: #fff;
}
.locations-con{
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0px 10px;
}
.locations {
    height: 50vh;
    overflow: scroll;   

}
.location{
    column-gap: 8px;
    width: 170px;
    justify-content: start;    
}
.checkbox{
    width: 30px;
    height: 30px;
}
.v-input--selection-controls{
    margin-top: 6px;
}
.location-item{
    margin: 0px;
}
.input-field{
    border: 1px solid #BFBFBF;
    width: 100%;
    border-radius: 5px;
    padding: 12px;
    margin: 20px auto 10px;
}
.v-application p {
    margin-top: 6px;
    font-size: 0.9rem;
    margin-bottom: 0px;
}
</style>